import styled from "styled-components";
import theme from "../../../Themes/light";
import { ThemeType } from "../../../types/Theme";

const FreteEspecialMainContainer = styled.div<{theme: ThemeType}>`
  width: 100%;
  .dropdown {
    .novo {
      cursor: pointer;
      margin-top: 0;
      text-align: center;
      color: ${({theme}) => theme.colors.primary};
    }
  }
`;

export { FreteEspecialMainContainer };
